import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ProfileLinkRequest from "apps/messenger/components/MainWindow/MessagePane/ProfileLinkRequest";
import {
	onProfileLinkAccept,
	onProfileLinkReject,
} from "ducks/global_messaging";

const mapStateToProps = undefined;
const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			onProfileLinkAccept,
			onProfileLinkReject,
		},
		dispatch,
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(ProfileLinkRequest);



// WEBPACK FOOTER //
// ./src/apps/messenger/containers/ProfileLinkRequest.js